import { OnboardingGrid } from "apps/oneOnboarding/OnboardingGrid";
import { OneOnboardingSkeleton } from "apps/oneOnboarding/Skeleton";
import { PropertyForm } from "apps/oneOnboarding/form/PropertyForm";
import { Notifications } from "apps/oneOnboarding/notification/Notifications";
import { Sidebar } from "apps/oneOnboarding/sidebar";
import { useStaticDataAtomValue } from "apps/oneOnboarding/staticDataAtom";
import { useMetadataApi } from "apps/oneOnboarding/useMetadataApi";
import { usePropertyDataApi } from "apps/oneOnboarding/usePropertyDataApi";
import { useEffect } from "react";
import { Outlet, useLocation } from "react-router";

const Layout = () => {
    const staticData = useStaticDataAtomValue();
    const { isLoading: isLoadingPropertyData, data: propertyData, refetch: refetchPropertyData } = usePropertyDataApi();
    const { isLoading: isLoadingMetadata, data: metadataData, refetch: refetchMetadata } = useMetadataApi();

    const location = useLocation();

    const handleRefetch = () => {
        refetchPropertyData();
        refetchMetadata();
    };

    useEffect(() => {
        if (location.state && location.state.shouldRefetch) {
            handleRefetch();
            // Clean up state to prevent refetching on future renders
            window.history.replaceState({}, document.title);
        }
    }, [location.state]);

    return (
        <>
            <OnboardingGrid
                sidebar={<Sidebar />}
                content={
                    staticData === undefined ||
                    propertyData === undefined ||
                    isLoadingPropertyData ||
                    metadataData === undefined ||
                    isLoadingMetadata ? (
                        <OneOnboardingSkeleton />
                    ) : (
                        <PropertyForm data={propertyData}>
                            <Outlet />
                        </PropertyForm>
                    )
                }
            />
            {staticData !== undefined && <Notifications />}
        </>
    );
};

export default Layout;
